import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import PersonalBlog from "../containers/HomePage"
import SEO from "../components/seo"

const PersonalBlogPage = (props: any) => {
  const { data } = props

  return (
    <Layout>
      <SEO
        title="We Keep you fit Blog"
        description={data.site.siteMetadata.description}
      />
      <PersonalBlog />
    </Layout>
  )
}

export default PersonalBlogPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description
      }
    }
    allContentfulBlogPost(sort: { fields: datePosted, order: DESC }) {
      edges {
        node {
          postBody {
            childMarkdownRemark {
              excerpt
            }
          }
          slug
          datePosted(formatString: "DD [<span>] MMMM [</span>]")
          postTitle
          category
          postImage {
            fluid(maxWidth: 570, quality: 90) {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
`
